"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const patched_browser_plugin_button_click_tracking_1 = require("@angi/patched-browser-plugin-button-click-tracking");
const utils_1 = require("../../utils");
const buttonClickTrackingWithDynamicContexts = (enabled, dynamicEntities = [], additionalEntities = []) => {
    return {
        enabled,
        plugin: patched_browser_plugin_button_click_tracking_1.ButtonClickTrackingPlugin,
        enablePlugin: () => {
            (0, patched_browser_plugin_button_click_tracking_1.enableButtonClickTracking)({
                context: [
                    ...(0, utils_1.generateDynamicButtonClickContextFunctions)(dynamicEntities),
                    ...additionalEntities,
                ],
            });
        },
    };
};
exports.default = buttonClickTrackingWithDynamicContexts;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnV0dG9uQ2xpY2tUcmFja2luZ1dpdGhEeW5hbWljQ29udGV4dHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcGx1Z2lucy9vdmVycmlkZXMvYnV0dG9uQ2xpY2tUcmFja2luZ1dpdGhEeW5hbWljQ29udGV4dHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxxSEFHNEQ7QUFHNUQsdUNBQXlFO0FBR3pFLE1BQU0sc0NBQXNDLEdBQUcsQ0FDM0MsT0FBZ0IsRUFDaEIsa0JBQWtDLEVBQUUsRUFDcEMscUJBQTZFLEVBQUUsRUFDbkUsRUFBRTtJQUNkLE9BQU87UUFDSCxPQUFPO1FBQ1AsTUFBTSxFQUFFLHdFQUF5QjtRQUNqQyxZQUFZLEVBQUUsR0FBRyxFQUFFO1lBQ2YsSUFBQSx3RUFBeUIsRUFBQztnQkFDdEIsT0FBTyxFQUFFO29CQUNMLEdBQUcsSUFBQSxrREFBMEMsRUFBQyxlQUFlLENBQUM7b0JBQzlELEdBQUcsa0JBQWtCO2lCQUN4QjthQUNKLENBQUMsQ0FBQztRQUNQLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUYsa0JBQWUsc0NBQXNDLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/plugins/overrides/buttonClickTrackingWithDynamicContexts.ts